import { MapPin, Phone } from 'lucide-react';
export default function Contact() {
  return (
    <section id="kontakt" className="contact">
      <div className="contact-container">
        <div className="section-header">
          <h2 className="section-title">Kontakt</h2>
        </div>

        <div className="contact-grid contact-centered"> 
          <div className="contact-info-wrapper-centered"> 
            <div className="contact-info-card">
              <h3 className="contact-info-title">Kontaktinformationen</h3>
              <div className="contact-info-items">
                <div className="contact-info-item">
                  <div className="contact-icon-wrapper">
                    <MapPin color="white" size={24} />
                  </div>
                  <div className="contact-info-content">
                    <p className="contact-info-label">Adresse</p>
                    <p className="contact-info-text">
                      Waldburgstraße 1<br />
                      6714 Nüziders, Österreich
                    </p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-icon-wrapper">
                    <Phone color="white" size={24} />
                  </div>
                  <div className="contact-info-content">
                    <p className="contact-info-label">Telefon</p>
                    <p className="contact-info-text">05552/22025</p>
                    <p className="contact-info-text">+43 664 5749684</p>
                  </div>
                </div>
              </div>
            </div>
            <p className="contact-info-label-note"> 
              <strong>Hinweis:</strong> Terminvereinbarung nur montags, dienstags und donnerstags zwischen 8:00 und 11:00 - ausschließlich telefonisch.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
